<template>
  <a-modal
      title="发票列表,请点击链接进行下载"
      :width="800"
      :visible="visible"
      :confirmLoading="loading"
      :maskClosable="false"
      @ok="handleSubmit"
      @cancel="() => { $emit('onClose') }"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="invoiceEditForm"
        :model="editForm"
        :rules="editFormRules"
        :label-col="formLayout.labelCol"
        :wrapper-col="formLayout.wrapperCol"
      >
        <a-form-model-item
          label="名称"
          required
          prop="buyerName"
        >
          <a-input
            v-model="editForm.buyerName"
            placeholder="请输入名称"
          />
        </a-form-model-item>
        <a-form-model-item
          label="纳税人识别号"
          prop="buyerTaxNumber"
        >
          <a-input
            v-model="editForm.buyerTaxNumber"
            placeholder="请输入纳税人识别号"
          />
        </a-form-model-item>
        <a-form-model-item
          label="电子邮箱"
          required
          prop="email"
        >
          <a-input
            v-model="editForm.email"
            placeholder="请输入电子邮箱"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
const iForm = {buyerName:undefined,buyerTaxNumber: undefined,email: undefined}
const editFormRules = {
  buyerName:[
    {required: true, message: '请输入名称'},
    {type:'string', min:1,max:50, message: '名称长度在1~50之间'}
  ],
  email:[
    {required: true, message: '请输入电子邮箱'},
    {type: 'email', message: '请输入正确的邮箱地址',}
  ],
}
export default {
  name: 'InvoiceEditModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    },
  },
  data() {
    const formLayout = {
      labelCol: {
        xs: {span: 20},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 20},
        sm: {span: 17}
      }
    }
    return {
      editForm: iForm,
      formLayout,
      editFormRules,
      activeKey: 1,
      sourceData: []
    }
  },
  created() {

  },
  methods: {
    handleSubmit(){
      this.$refs.invoiceEditForm.validate(valid=>{
        if (valid) {
          this.$emit('submit', this.editForm)
        }
      })
    },
  },
  watch: {
    visible(show) {//普通的watch监听
      if (show && this.model) {
        this.editForm = this.model
      }
    },
  }
}
</script>
